(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-explainer-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-lp-explainer-player]').forEach(function (player) {
      var trigger = player.querySelector('[data-lp-explainer-trigger]');
      var template = player.querySelector('[data-lp-explainer-template]');
      if (!trigger || !template) return;
      trigger.addEventListener('click', function () {
        var fragment = template.content.cloneNode(true);
        var video = fragment.querySelector('video');
        player.replaceChildren(fragment);
        if (video) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') { playPromise.catch(function () {}); }
          video.focus({ preventScroll: true });
        }
      }, { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (typeof HTMLDialogElement === 'undefined') return;

  var lastFocused = null;

  function onClose() {
    document.documentElement.classList.remove('is-modal-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus({ preventScroll: false }); } catch (err) {}
    }
  }

  function attachCloseListeners(root) {
    var dialogs = (root || document).querySelectorAll('dialog.landing-footer__modal');
    dialogs.forEach(function (d) {
      if (d.__lfMCloseAttached) return;
      d.__lfMCloseAttached = true;
      d.addEventListener('close', onClose);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.landing-footer [data-modal-trigger]');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('data-modal-trigger');
      var dialog = document.getElementById(id);
      if (dialog && typeof dialog.showModal === 'function') {
        lastFocused = document.activeElement;
        try {
          dialog.showModal();
          document.documentElement.classList.add('is-modal-open');
        } catch (err) {}
      }
      return;
    }

    var closer = e.target.closest && e.target.closest('.landing-footer__modal-close, [data-modal-close]');
    if (closer) {
      var d = closer.closest('dialog.landing-footer__modal');
      if (d) try { d.close(); } catch (err) {}
      return;
    }

    // Backdrop click: card swallows its own clicks, so e.target === dialog.
    if (e.target && e.target.matches && e.target.matches('dialog.landing-footer__modal')) {
      try { e.target.close(); } catch (err) {}
    }
  });

  // The `close` event does not bubble, so attach listeners on each dialog.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attachCloseListeners(); });
  } else {
    attachCloseListeners();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('section-landing-footer')) {
      attachCloseListeners(e.target);
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target) return;
    if (!e.target.closest || !e.target.closest('.section-landing-footer')) return;
    var trigger = e.target.querySelector && e.target.querySelector('[data-modal-trigger]');
    if (!trigger) return;
    var id = trigger.getAttribute('data-modal-trigger');
    var dialog = document.getElementById(id);
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      try {
        lastFocused = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('is-modal-open');
      } catch (err) {}
    }
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    if (!e.target) return;
    if (!e.target.closest || !e.target.closest('.section-landing-footer')) return;
    var trigger = e.target.querySelector && e.target.querySelector('[data-modal-trigger]');
    if (!trigger) return;
    var id = trigger.getAttribute('data-modal-trigger');
    var dialog = document.getElementById(id);
    if (dialog && dialog.open) {
      try { dialog.close(); } catch (err) {}
    }
  });
})();

/**
 * Prevents an orphaned last link on its own wrapped line: when the last
 * item sits alone, insert a break <li> before the second-to-last item so
 * the trailing two wrap together. On desktop everything fits in one row,
 * so no break is added — mobile-only behaviour without a media query.
 */
(function () {
  function preventOrphan(list) {
    if (!list) return;
    list.querySelectorAll('.landing-footer__break').forEach(function (el) {
      el.remove();
    });
    var items = Array.from(list.querySelectorAll(':scope > .landing-footer__item'));
    if (items.length < 3) return;
    var lastTop = items[items.length - 1].offsetTop;
    var secondLastTop = items[items.length - 2].offsetTop;
    if (lastTop === secondLastTop) return;
    var breakEl = document.createElement('li');
    breakEl.className = 'landing-footer__break';
    breakEl.setAttribute('aria-hidden', 'true');
    list.insertBefore(breakEl, items[items.length - 2]);
  }

  function runAll() {
    document.querySelectorAll('.landing-footer__links').forEach(preventOrphan);
  }

  var debounceTimer;
  function debouncedRun() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runAll, 100);
  }

  if (!window.__landingFooterOrphanInit) {
    window.__landingFooterOrphanInit = true;
    window.addEventListener('resize', debouncedRun, { passive: true });
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(runAll);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-landing-footer')) {
        runAll();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
